import type { CampaignUnit } from '@/services/api/types';
import { Tile, ContentGrid } from './Tiles.styles';
import { useLoader } from '@CS/hooks';
import { Theme } from '@/theme';
import { useEffect, useState } from 'react';
import { getCampaignId } from '@/redux/campaign/selectors';
import api from '@/services/api';
import { useSelector } from 'react-redux';

export type Size = 'small' | 'medium' | 'large';

export const Tiles = () => {
  const [loading, setLoading] = useState(true);
  const loader = useLoader(loading, { color: Theme.color.red });

  const [tiles, setTiles] = useState<CampaignUnit[]>();

  const campaignId = useSelector(getCampaignId);

  useEffect(() => {
    if (!campaignId) return;

    const fetchTiles = async () => {
      try {
        const campaignUnit = await api.getCampaignUnits();
        setTiles(campaignUnit);
      } finally {
        setLoading(false);
      }
    };

    fetchTiles();
  }, [campaignId]);

  const handleClick = (href: string) => {
    window.location.href = href;
  };

  const getTileBackground = (bgColor?: string, bgImage?: string) => {
    if (bgColor && bgImage)
      return { background: `${bgColor} url(${bgImage}) center/cover no-repeat` }
    if (bgColor)
      return { background: bgColor }
    if (bgImage)
      return { background: `url(${bgImage}) center/cover no-repeat` }
    return {}
  }

  return loader || (
    <ContentGrid>
      {tiles && tiles.map((tile, index) => (
        <Tile
          key={index}
          href={tile.ctaUrl}
          $size={tile.itemType as Size}
          data-size={tile.itemType}
          style={getTileBackground(tile.bgColor, tile.bgImageUrls && tile.bgImageUrls[0])}
          onClick={() => handleClick(tile.ctaUrl)}
        >
          {tile.itemType === 'large' ? (
            <>
              <figure>
                <img src={tile.imageUrls[0]} alt={tile.title} width="177" height="116" />
              </figure>
              <article>
                <h3>{tile.title}</h3>
                <p>{tile.description}</p>
              </article>
            </>
          ) : (
            <>
              <figure>
                <img src={tile.imageUrls[0]} alt={tile.title} width="70" height="70" />
              </figure>
              <h3>{tile.title}</h3>
              <p>{tile.description}</p>
            </>
          )}
        </Tile>
      ))}
    </ContentGrid>
  );
};
